export default __webpack_public_path__ + "static/media/fa-brands-400.97120c26.woff2";